import React, { useEffect, useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Utils from "../../../utils";
import { ADMIN_LOCAL_STORE } from "../../../configs/AppConfig";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import DocusafeLogo from "../../../assets/Images/Docusafe_logo.webp";
import "../adminportal.css";

function AdminHeader() {

    const navigate = useNavigate();
    const [adminDisplayName, setAdminDisplayName] = useState('');
    const [adminLoginUserName, setAdminLoginUserName] = useState('');
    const [adminLoginUserEmail, setAdminLoginUserEmail] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const userMenuRef = useRef(null);

    useEffect(() => {
        setAdminDisplayName(Utils.adminDisplayName());
        let loginData = Utils.adminLoginUserData();
        if (Object.keys(loginData).length > 0) {
            setAdminLoginUserName(loginData.first_name + ' ' + loginData.last_name);
            setAdminLoginUserEmail(loginData.email);
        }

        // Close dropdown when clicking outside
        function handleClickOutside(event) {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setIsUserMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const onLogout = () => {
        localStorage.removeItem(ADMIN_LOCAL_STORE);
        navigate('/back-admin/login');
    };

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    const toggleUserMenu = () => {
        setIsUserMenuOpen(!isUserMenuOpen);
    };

    return (
        <nav className="admin-header-dark navbar navbar-expand-lg fixed-top admin-header">
            <div className="container-fluid">
                <NavLink to="/back-admin" className="admin-header-logo-link">
                    <img
                        src={DocusafeLogo}
                        alt="DocuSafe Logo"
                        className="admin-header-logo bg-white rounded"
                    />
                </NavLink>
                <button className="admin-header-toggle" onClick={toggleNavbar}>
                    {isOpen ? (
                        <IoMdClose size={24} className="admin-header-toggle-icon" />
                    ) : (
                        <GiHamburgerMenu size={24} className="admin-header-toggle-icon" />
                    )}
                </button>

                <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarContent">
                    <ul className="navbar-nav admin-header-links">
                        <li className="nav-item">
                            <NavLink
                                to={"/back-admin"}
                                className={({ isActive }) =>
                                    `nav-link${isActive ? " active" : ""}`
                                }
                                end
                            >
                                Dashboard
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                to={"/back-admin/adminportal"}
                                className={({ isActive }) =>
                                    `nav-link${isActive ? " active" : ""}`
                                }
                                end
                            >
                                Admin
                            </NavLink>
                        </li>
                        {/* <li className="nav-item">
                            <NavLink
                                to={"/back-admin/subscribers"}
                                className={({ isActive }) =>
                                    `nav-link${isActive ? " active" : ""}`
                                }
                            >
                                Subscribers
                            </NavLink>
                        </li> */}
                        <li className="nav-item">
                            <NavLink
                                to={"/back-admin/2fa"}
                                className={({ isActive }) =>
                                    `nav-link${isActive ? " active" : ""}`
                                }
                            >
                                2FA
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink
                                to={"/back-admin/template"}
                                className={({ isActive }) =>
                                    `nav-link${isActive ? " active" : ""}`
                                }
                            >
                                Template
                            </NavLink>
                        </li>
                        {/* <li className="nav-item">
                            <NavLink
                                to={"/back-admin/summary-prompt"}
                                className={({ isActive }) =>
                                    `nav-link${isActive ? " active" : ""}`
                                }
                            >
                                Prompt
                            </NavLink>
                        </li> */}
                        {/* <li className="nav-item">
                            <NavLink
                                to={"/back-admin/files"}
                                className={({ isActive }) =>
                                    `nav-link${isActive ? " active" : ""}`
                                }
                            >
                                Files 
                            </NavLink>
                        </li> */}

                    </ul>

                    <div className="admin-header-user-container admin-header-user-small-screen" ref={userMenuRef}>
                        <div className="admin-header-user-dropdown">
                            <span className="admin-header-user-btn" role="button" onClick={toggleUserMenu}>{adminDisplayName}</span>
                            <ul className={`admin-header-user-menu ${isUserMenuOpen ? 'show' : ''}`}>
                                <li className="admin-header-user-company">DocuSafe.ai Pty Ltd</li>
                                <li className="admin-header-user-info">
                                    <span className="admin-header-user-icon">{adminDisplayName}</span>
                                    <p>
                                        <span className="admin-header-user-name">{adminLoginUserName}</span>
                                        <span className="admin-header-user-email">{adminLoginUserEmail}</span>
                                        {/* <span className="admin-header-user-profile">
                                        <NavLink to={"/back-admin"} className="admin-header-user-profile-link">Profile</NavLink>
                                    </span> */}
                                    </p>
                                </li>
                                <li className="admin-header-user-signout">
                                    <span onClick={onLogout} className="admin-header-user-signout-btn">Sign Out</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="admin-header-user-container admin-header-user-large-screen" ref={userMenuRef}>
                    <div className="admin-header-user-dropdown">
                        <span className="admin-header-user-btn" role="button" onClick={toggleUserMenu}>{adminDisplayName}</span>
                        <ul className={`admin-header-user-menu ${isUserMenuOpen ? 'show' : ''}`}>
                            <li className="admin-header-user-company">DocuSafe.ai Pty Ltd</li>
                            <li className="admin-header-user-info">
                                <span className="admin-header-user-icon">{adminDisplayName}</span>
                                <p>
                                    <span className="admin-header-user-name">{adminLoginUserName}</span>
                                    <span className="admin-header-user-email">{adminLoginUserEmail}</span>
                                    {/* <span className="admin-header-user-profile">
                                        <NavLink to={"/back-admin"} className="admin-header-user-profile-link">Profile</NavLink>
                                    </span> */}
                                </p>
                            </li>
                            <li className="admin-header-user-signout">
                                <span onClick={onLogout} className="admin-header-user-signout-btn">Sign Out</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav >
    );
}

export default AdminHeader;